module.exports = require("@agm/core/directives/marker");